<template>
  <div
    id="margins-container"
    class="row gutters-0"
  >
    <div
      class="col-4 d-flex flex-column justify-content-between"
    >
      <base-counter
        :value="top"
        :disabled="disabled"
        ref="logoMarginTop"
        unit="px"
        prepend-icon="fa-arrow-down-to-line"
        @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
        @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
        @updateValue="update('logoMarginTop', $event)"
      />
      <base-counter
        :value="left"
        :disabled="disabled"
        ref="logoMarginLeft"
        unit="px"
        prepend-icon="fa-arrow-right-to-line"
        @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
        @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
        @updateValue="update('logoMarginLeft', $event)"
      />
    </div>
    <div
      class="col-4 d-flex align-items-center justify-content-center"
    >
      <b-button
        variant="secondary"
        size="sm"
        :value="linked"
        :disabled="disabled"
        :title="linked ? 'Unlink Margins' : 'Link Margins'"
        @click="toggleMarginsLink(!linked)"
      >
        <i :class="['fal ', `fa-link${linked ? '': '-slash'}`]" />
      </b-button>
    </div>
    <div
      class="col-4 d-flex flex-column justify-content-between"
    >
      <base-counter
        :value="bottom"
        :disabled="disabled"
        unit="px"
        ref="logoMarginBottom"
        prepend-icon="fa-arrow-up-to-line"
        @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
        @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
        @updateValue="update('logoMarginBottom', $event)"
      />
      <base-counter
        :value="right"
        :disabled="disabled"
        unit="px"
        ref="logoMarginRight"
        prepend-icon="fa-arrow-left-to-line"
        @focus="SET_IS_SIDEBAR_INPUT_FOCUSED(true)"
        @blur="SET_IS_SIDEBAR_INPUT_FOCUSED(false)"
        @updateValue="update('logoMarginRight', $event)"
      />
    </div>
  </div>
</template>
<script>

import BaseCounter from '@/components/BaseCounter.vue';
import { mapActions } from 'vuex';
import * as contentTypes from '@/modules/content/store/types';

export default {
  name: 'MarginGroup',
  components: { BaseCounter },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    left: {
      type: Number,
      default: 0,
    },
    right: {
      type: Number,
      default: 0,
    },
    top: {
      type: Number,
      default: 0,
    },
    bottom: {
      type: Number,
      default: 0,
    },
    linked: Boolean,
    default: Boolean(false),
  },
  computed: {
    allTypes() {
      return ['logoMarginRight', 'logoMarginLeft', 'logoMarginBottom', 'logoMarginTop'];
    },
  },
  methods: {
    ...mapActions('content', [
      contentTypes.SET_IS_SIDEBAR_INPUT_FOCUSED,
    ]),
    toggleMarginsLink(areLinked) {
      this.$emit('updateValue', areLinked);
    },
    update(currentType, value) {
      const margins = {};
      if (this.linked) {
        this.updateOthers(currentType, value);
        this.allTypes.forEach((type) => {
          margins[type] = value;
        });
      } else {
        margins[currentType] = value;
      }
      this.$emit('updateValues', margins);
    },
    updateOthers(currentType, value) {
      this.getAllTypesBut(currentType).forEach((type) => {
        this.$refs[type].inputValue = value;
      });
    },
    getAllTypesBut(marginType) {
      return this.allTypes.filter((type) => type !== marginType);
    },
  },
};
</script>
